import { useEffect, useState } from "react";
import { nextAppEnv } from "@Utils/environment";
import { isCanadianLocale } from "@Utils/locale";
import { ILocaleDetail } from "@wff/interfaces";
import { useAppSelector } from "@wff/store/hooks";
import { localeSelector } from "@wff/store/localeSlice";
import { useCustomer } from "./useCustomer";

export const getMembershipConfigObj = (
  isLoggedInUser: boolean,
  isMember: boolean,
  currentLocale: ILocaleDetail
) => {
  const membershipFeatureEnabled =
    nextAppEnv.feature_toggle.CA.membership === "true" ? true : false;
  const showUnlockFreeDelBtn: boolean =
    !(isLoggedInUser && isMember) &&
    isCanadianLocale(currentLocale) &&
    membershipFeatureEnabled;

  //'Become a Member' Top Navigation Menu item appears if the user is logged in and a member and from CA
  const showTopNavMenusItemBecomeMember =
    !isCanadianLocale(currentLocale) && membershipFeatureEnabled;

  const showBecomeMemberBtnInSideNav =
    isCanadianLocale(currentLocale) && !isMember && membershipFeatureEnabled;

  return {
    showUnlockFreeDelBtnForCA: showUnlockFreeDelBtn,
    showTopNavMenusItemBecomeMemberForCA: showTopNavMenusItemBecomeMember,
    showBecomeMemberBtnInSideNavForCA: showBecomeMemberBtnInSideNav,
  };
};

export const useMembershipForCA = () => {
  const [membershipConfigObj, setMembershipConfigObj] = useState({
    showUnlockFreeDelBtnForCA: false,
    showTopNavMenusItemBecomeMemberForCA: false,
    showBecomeMemberBtnInSideNavForCA: false,
  });
  const isLoggedInUser = useCustomer().isLoggedIn;
  const currentLocale = useAppSelector(localeSelector);
  const { isMember } = useCustomer();
  const isCanadaUser = isCanadianLocale(currentLocale);

  useEffect(() => {
    if (isCanadaUser) {
      const membershipConfigObjForCA = getMembershipConfigObj(
        isLoggedInUser,
        isMember,
        currentLocale
      );

      setMembershipConfigObj(membershipConfigObjForCA);
    }
  }, [isCanadaUser, isMember, isLoggedInUser, currentLocale]);

  return membershipConfigObj;
};
